import api from './api';
// Updated to use port 5174
export const authService = {
  // Login
  login: async (username, password) => {
    const response = await api.post('/auth/login', { username, password });
    return response.data;
  },

  verifyTwoFactor: async (challengeToken, code) => {
    const response = await api.post('/auth/verify-2fa', { challengeToken, code });
    return response.data;
  },

  getTwoFactorStatus: async () => {
    const response = await api.get('/auth/2fa/status');
    return response.data;
  },

  beginTwoFactorSetup: async () => {
    const response = await api.post('/auth/2fa/setup');
    return response.data;
  },

  confirmTwoFactorSetup: async (code) => {
    const response = await api.post('/auth/2fa/confirm', { code });
    return response.data;
  },

  disableTwoFactor: async (password, code) => {
    const response = await api.post('/auth/2fa/disable', { password, code });
    return response.data;
  },

  regenerateRecoveryCodes: async (code) => {
    const response = await api.post('/auth/2fa/recovery-codes/regenerate', { code });
    return response.data;
  },

  // Logout
  logout: async () => {
    await api.post('/auth/logout');
  },

  // Get current user.
  // Anonymous visitors always hit 401 here; treat that as null rather than an
  // axios error so the login page is not blocked and DevTools does not look
  // like a failed request chain for the expected unauthenticated case.
  getCurrentUser: async () => {
    const response = await api.get('/auth/me', {
      validateStatus: (status) => (status >= 200 && status < 300) || status === 401,
    });
    if (response.status === 401) return null;
    return response.data;
  },

  // Change password
  changePassword: async (currentPassword, newPassword) => {
    const response = await api.post('/auth/change-password', {
      currentPassword,
      newPassword,
    });
    return response.data;
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    return false;
  },
};

export default authService;
